const createGlobalLoader = () => {
  console.log("Creating global loader");

  // Find the parent element where the loader should appear (for example, a product container)
  const productsContainer = document.querySelector("#ProductGridContainer"); // Adjust the selector to match your product container's class

  // If the products container is found, append the loader
  if (productsContainer) {
    const globalLoader = document.createElement("div");
    globalLoader.classList.add("global-loader");
    globalLoader.innerHTML = `<div class="loader"></div>`;
    productsContainer.appendChild(globalLoader); // Append the loader below the products container
    globalLoader.style.display = "none"; // Hide by default
  } else {
    console.error("Products container not found.");
  }
};

// The rest of your existing code remains the same

const showLoader = () => {
  console.log("Showing loader");
  const loader = document.querySelector(".global-loader");
  if (loader) {
    loader.style.display = "block";
  } else {
    console.error("Global loader not found.");
  }
};

const hideLoader = () => {
  console.log("Hiding loader");
  const loader = document.querySelector(".global-loader");
  if (loader) {
    loader.style.display = "none";
  } else {
    console.error("Global loader not found.");
  }
};

const loadItems = (button) => {
  const totalPages = parseInt($("[data-total-pages]").val());
  let currentPage = parseInt($("[data-current-page]").val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
  const nextUrl = $("[data-next-url]")
    .val()
    .replace(/page=[0-9]+/, "page=" + currentPage);
  const nextUrlScroll = $("[data-next-url]")
    .val()
    .replace(/page=[0-9]+/, "page=" + currentPageScroll);
  $("[data-current-page]").val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add("loading");

  // Show the global loader
  showLoader();

  $.ajax({
    url: nextUrl,
    type: "GET",
    dataType: "html",
    success: function (responseHTML) {
      $(".load-more-grid").append(
        $(responseHTML).find(".load-more-grid").html()
      );
      // colorSwatches();
    },
    complete: function () {
      // Hide the global loader
      hideLoader();

      if (currentPage <= totalPages) {
        const scollData = document.querySelector(".infinite-scroll__data");
        if (scollData && currentPage != totalPages) {
          scollData.querySelector("input[data-next-url]").dataset.nextUrl =
            nextUrlScroll;
          scollData.querySelector("input[data-next-url]").value = nextUrlScroll;
          scollData.querySelector(
            "input[data-current-page]"
          ).dataset.currentPage = currentPage;
          scollData.querySelector("input[data-current-page]").value =
            currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove("loading");
        if (currentPage == totalPages) {
          button.remove();
        }
      }
    },
  });
};

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll(".js-infinite-scroll");
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
};

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

(function () {
  createGlobalLoader(); // Create the global loader
  loadMore();
})();
